import {
  Alert,
  Button,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { useDI } from "@infra/di/useDI";
import { useRegistrationCancelViewModel } from "./CancelViewModel";
import { AuthCard, AuthContent, AuthPage } from "../layout";

export default function RegistrationCancelPage() {
  const { registrationId } = useParams<{ registrationId: string }>();
  const { registrationService } = useDI();

  const { state, intents } = useRegistrationCancelViewModel({
    registrationId,
    registrationService,
  });

  return (
    <AuthPage>
      <AuthCard>
        <AuthContent>
          <Stack spacing={3} alignItems="center">
            {state.isBusy ? <CircularProgress /> : null}

            <Stack spacing={1} alignItems="center">
              <Typography variant="h5" fontWeight={700} textAlign="center">
                {state.uiState.title}
              </Typography>

              <Typography
                variant="body1"
                color="text.secondary"
                textAlign="center"
              >
                {state.uiState.message}
              </Typography>
            </Stack>

            {state.uiState.status === "error" ? (
              <Alert severity="warning" sx={{ width: "100%" }}>
                {state.uiState.message}
              </Alert>
            ) : null}

            {state.canActOnCheckout ? (
              <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                <Button
                  variant="outlined"
                  onClick={intents.cancelCheckout}
                  disabled={state.isBusy}
                >
                  Bezahlvorgang abbrechen
                </Button>

                <Button
                  variant="contained"
                  onClick={intents.resumeCheckout}
                  disabled={state.isBusy}
                >
                  Bezahlung fortsetzen
                </Button>
              </Stack>
            ) : (
              <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                {state.uiState.status === "error" && state.uiState.canRetry ? (
                  <Button
                    variant="outlined"
                    onClick={intents.refresh}
                    disabled={state.isBusy}
                  >
                    Erneut laden
                  </Button>
                ) : null}

                <Button
                  variant="contained"
                  onClick={intents.goToLandingPage}
                  disabled={state.isBusy}
                >
                  Zur Startseite
                </Button>
              </Stack>
            )}
          </Stack>
        </AuthContent>
      </AuthCard>
    </AuthPage>
  );
}
